import MySkills from "@pages/MySkills";
import { NavLink } from "react-router-dom";
import useTranslations from "@hooks/useTranslations";
import { ICONS } from "@utils/icons";

const About = () => {
  const t = useTranslations();

  return (
    <>
      <div className="bostami-page-content-wrap">
        <div className="section-wrapper pl-60 pr-60 pt-60">
          <div className="bostami-page-title-wrap mb-15">
            <h1 className="page-title">{t.about.title}</h1>
            {t.about.bio.map((paragraphe) => (
              <p key={paragraphe.slice(0, 40)}>{paragraphe}</p>
            ))}
            <div className="d-flex justify-content-end gap-3">
              <NavLink to="/resume">
                <button type="button" className="form-btn">
                  {t.about.cvBtn} <i className={ICONS.chevronRight} />
                </button>
              </NavLink>
              <NavLink to="/portfolio">
                <button type="button" className="form-btn">
                  {t.about.portfolioBtn} <i className={ICONS.chevronRight} />
                </button>
              </NavLink>
            </div>
          </div>
        </div>
        <MySkills />
      </div>
    </>
  );
};

export default About;
